<template>
  <div class="comp-new-cates">
    <div ref="tabWrapper" class="wrapper">
      <div v-for="row in rowData" :key="row.id" class="row">
        <div class="row-title">{{ row.name }}:</div>
        <ul :ref="`ulRef${row.id}`" class="cate-list">
          <li
            v-for="cate in row.data"
            ref="liRef"
            :key="cate.id"
            class="cate-item"
            :style="{margin: unfoldliMargin}"
          >
            <span
              :class="['cate-core',{'cate-core_active': cate.id == cateSelected.id }]"
              @click="selectCate(cate)"
            >{{ cate.name }}</span>
            <div class="lidivi" :ref="`lidivi${cate.id}`" :id="cate.id"></div>
            <div class="isnewlayout" :ref="`isnew${cate.id}`">
              <div
                class="isnew"
                v-if="(!cate.isnewFold && cate.cornerMarkType) || (cate.cornerMarkType && (!row.isFold && cate.isnewFold))"
              >{{cate.cornerMarkType == 1 ? 'NEW' : '上新'}}</div>
            </div>
          </li>
        </ul>
        <!-- 更多按钮 v-if="overheightRow.indexOf(row.id) !== -1" || (cate.cornerMarkType && (!row.isFold && cate.isnewFold))-->
        <div
          :style="{visibility: overheightRow.indexOf(row.id) !== -1 ? 'visible':'hidden'}"
          class="row-showmore"
          @click="showMoreClick(row)"
        >
          <span class="showmore-btn">
            <!-- ; row.isFold ? "更多" : "收起"  -->
            {{ row.isFold ? "更多" : "收起" }}
            <i
              :class="['fa', row.isFold ? 'fa-angle-down' : 'fa-angle-up']"
            ></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  props: {
    "specialUrl": {},
    hasChild: {type: Boolean, default: false},
    childName: {
      type: String,
      default: '分类'
    }
  },
  data() {
    return {
      rowData: [],
      cateSelected: {},
      keyword: "",
      initSelected: {}, // 初始选中的默认分类
      overheightRow: [], // 需要这行的分类行的key值
      currentRow: {},
      rowHeight: 20,
      unfoldliMargin: ""
    };
  },
  computed: {
    //...mapGetters(["loginStatus"]),
  },
  watch: {
    $route: function(newVal, oldVal) {},
    specialUrl: function(val) {
      this.fetchRowData(val);
    }
  },
  mounted() {
    if (!this.specialUrl) this.fetchRowData("/api/home/category?type=8");
    else this.fetchRowData(this.specialUrl);

    this.$bus.on("bus::cateClick", cate => {
      this.cateSelected = cate;
    });
  },
  methods: {
    //...mapMutations(["changeLoginVisible", ]),
    fetchRowData(api) {
      this.$http.get(api).then(({ data }) => {
        if (data.code !== 200 || !data.data) return;

        //cornerMarkType 不为null 显示最新
        function compare(property, isSequence = true) {
          return function(a, b) {
            var av = a[property];
            var bv = b[property];
            return isSequence ? av - bv : bv - av;
          };
        }

        if (this.specialUrl) {
          this.rowData = null;
          let rid = void 0;
          let vals = Object.values(data.data).sort(compare("power"));
          vals.unshift({ name: "全部", id: rid });
          this.rowData = [{ data: vals, name: this.hasChild ? "类型" : "分类", id: rid, isFold: true }];
        } else {
          this.rowData = Object.values(data.data)
            .filter(row => row.data)
            .sort(compare("power"))
            .map(row => {
              row.isFold = true; // 是否折叠
              return row;
            });
          this.rowData = this.rowData.map(row => {
            if (row.data) row.data.unshift({ name: "全部", id: row.id });
            return row;
          });
          //console.log("TCL: fetchRowData -> this.rowData", this.rowData)
        }

        this.$nextTick(() => {
          this.rowData.forEach(row => {
            const ul = this.$refs[`ulRef${row.id}`][0];
            if (!ul) return;
            const li = ul.querySelector(".cate-item");
            if (!li) return;
            if (ul.clientHeight > li.clientHeight) {
              //&& !this.specialUrl
              //列表的实际高度，包括超过高度
              ul.dataset.initHeight = ul.clientHeight;
              ul.style.height = `${this.rowHeight}px`;
            }
            this.$nextTick(() => {
              //重绘分割线
              let foldIndex = 0;
              for (let i = 0; i < row.data.length; i++) {
                let curr = this.$refs[`lidivi${row.data[i].id}`][0];
                let isnew = this.$refs[`isnew${row.data[i].id}`][0];
                if (isnew)
                  isnew.style.margin = `-7px 0px 0 ${row.data[i].name.length *
                    12 +
                    12}px`;
                if (row.data.length < 2 || i === row.data.length - 1) {
                  //末尾
                  curr.style.opacity = 0;
                  row.data[i].isnewFold =
                    i > foldIndex && i > 0 && foldIndex > 0;
                  break;
                }
                let next = this.$refs[`lidivi${row.data[i + 1].id}`][0];
                if (curr && next && curr.offsetTop != next.offsetTop) {
                  //折行
                  if (foldIndex === 0) foldIndex = i;
                  curr.style.opacity = 0;
                  this.overheightRow.push(row.id);
                }
                row.data[i].isnewFold = i > foldIndex && i > 0 && foldIndex > 0;
                //console.log(row.data[i].isnewFold, i, foldIndex)
              }
              //console.log('foreach', foldIndex, row.data)
            });
          });
        });

        this.cateSelected = this.initSelected = {
          name: "全部",
          id: this.rowData[0].id
        };
      });
    },
    /**
     * 从路由恢复分类选中状态
     */
    renewCateSelected() {
      // const { category, isMine, type } = this.$route.query;
      // let catesArr = this.rowData.map(row => row.data).flat();
      // let cs = isMine
      //   ? catesArr.find(cate => cate.type == type)
      //   : catesArr.find(cate => cate.id == category);
      // if (cs) {
      //   this.cateSelected = cs;
      //   //this.$emit("cateClick", cs);
      // }
    },
    selectCate(cate) {
      // if (cate.isMine && !this.loginStatus) {
      //   this.changeLoginVisible(true);
      //   return;
      // }
      this.cateSelected = cate;
      if (this.rowData.length > 1 && this.rowData[1].data.find(v => v.id === cate.id)) {

      }
      else if (cate.id === void 0) {
        this.rowData = [this.rowData[0]];
      } else {
        let list = cate.data || [];
        list = [{ name: "全部", id: cate.id }, ...list];
        let row = { data: list, name: this.childName, id: 'xx', isFold: true };
        this.rowData = [this.rowData[0], row];
      }
      this.$emit("cateClick", cate);
    },
    selectCateById(id) {
      let ito = null;
      let count = 0;
      ito = setInterval(() => {
        count ++;
        if(count > 300) clearInterval(ito);
        if (this.rowData[0].data.length > 0) {
          clearInterval(ito);
          for (let i = 0; i < this.rowData.length; i++) {
            let row = this.rowData[i];
            let cate = row.data.find(e => e.id === id);
            if (cate) {
              // this.cateSelected = cate;
              this.selectCate(cate);
              this.$emit("cateClick", cate);
              //console.log("selectCateById(id) 3", id, this.cateSelected, this.rowData);
              break;
            }
          }
        }
      }, 800);
    },
    // 点击切换分类列表的高度
    showMoreClick(row) {
      const ul = this.$refs[`ulRef${row.id}`][0];
      const initHeight = ul.dataset.initHeight;

      ul.style.height =
        ul.clientHeight <= this.rowHeight
          ? `${initHeight}px`
          : `${this.rowHeight}px`;

      // 更多按钮内容的切换
      this.rowData.forEach(item => {
        if (item.id === row.id) {
          item.isFold = !item.isFold;
          //console.log('switch fold', row.data)
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 0 0 0 0;
  padding-top: 0px;
  box-sizing: border-box;
  .row {
    margin: 0 0 15px 0;
    display: flex;
    width: 100%;
    .row-title {
      font-weight: bold;
      width: 65px;
      box-sizing: border-box;
      padding-left: 35px;
      text-align: left;
      color: #474261;
    }
    .cate-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      overflow: hidden;
      transition: height 0.4s ease;
      flex: 1;
      .cate-item {
        //min-width: 120px;
        box-sizing: border-box;
        height: 20px;
        //margin: 0 0 12px 0;
      }
      .cate-core {
        float: left;
        cursor: pointer;
        padding: 0px 20px;
        color: #474261;
        border-radius: 0px;
        &:hover {
          background-color: transparent;
          //color: #fff;
        }
      }
      .cate-core_active {
        background-color: transparent;
        color: #5778fb;
      }
      .lidivi {
        opacity: 0.3;
        position: relative;
        margin: 2px 0 0 0;
        float: left;
        width: 0px;
        height: 16px;
        border-right: 1px solid lightgrey;
      }
      .isnewlayout {
        position: absolute;
        width: 0px;
        height: 0px;
        .isnew {
          position: absolute;
          background-color: #ff4049;
          border-radius: 8px 4px 8px 0px;
          color: white;
          line-height: 16px;
          font-size: 12px;
          width: 34px;
          height: 16px;
          transform: scale(0.7);
        }
      }
    }
    .row-showmore {
      // visibility: hidden;
      width: 119px;
      //padding-top: 5px;
    }
    .showmore-btn {
      //padding: 5px 11px;
      border-radius: 12px;
      background-color: transparent;
      color: #333;
      cursor: pointer;
    }
  }
}
.cate-list .cate-item:last-of-type {
  & .lidivi {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/common/cates.vue